import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { User } from "../../pages/login/login.model";
import loginService from "./loginService";

interface ResetPasswordState {
  resetPasswordData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: ResetPasswordState = {
  resetPasswordData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//login recover slice - forgot username & forgot password
export const resetPassword = createAsyncThunk("auth/reset-password", async (userData: User, thunkAPI) => {
  try {
    const response = await loginService.resetPasswordService(userData);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    resetResetPassword: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.resetPasswordData = action.payload;
      })
      .addCase(resetPassword.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetResetPassword } = resetPasswordSlice.actions;
